import React from 'react';
import { Base } from './base';
import { TileV2Props } from './tile-v2.types';
import { Avatar } from './avatar';

export const TileV2 = (props: TileV2Props) => <Base {...props} />;

TileV2.Avatar = Avatar;
